import Vue from "vue";
import ResourceService from "./resource.service";
class TripService extends ResourceService {
  static get resource() {
    return "trip";
  }

  static assignVehicle(slug, data) {
    const url = `${this.resource}/${slug}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static salesOrderTrips(reservationId, params = {}) {
    return this.get(`sales-order/${reservationId}`, params);
  }

  static bulkCancel(data) {
    return this.put(data, "bulk/cancel");
  }

  static bulkReschedule(data) {
    return this.put(data, "bulk/reschedule");
  }

  static unassignDriver(data) {
    const url = `${this.resource}/unassign-driver`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static unassignSecondaryDriver(data) {
    const url = `${this.resource}/unassign-secondary-driver`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static downloadTrips(params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download`, {
          responseType: "blob",
          params,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static downloadTripsContracts(params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download-for-contract`, {
          responseType: "blob",
          params,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static importTrips(file) {
    const formData = new FormData();
    formData.append("import-trips-resources-file", file);
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`${this.resource}/import-trips-resources`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getImportLogs(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/import-trip-logs`, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getImportLogById(id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/import-trip-logs/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default TripService;
